module.exports = __webpack_public_path__ + "img/Freefilechecks.86cafe80.svg";